"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./style.scss");
// initialize storage before UI
var Storage_1 = require("./modules/Storage");
Storage_1.default.getLocalStorage();
var UI_1 = require("./modules/UI");
UI_1.default.init();
